import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { VoucherReport_voucherReport_edges_node } from "../../types/VoucherReport";
import VoucherList from "../VoucherList";
import {
  createFilterStructure,
  VoucherReportsFilterKeys,
  VoucherReportsListFilterOpts
} from "./filters";

interface VoucherListPageProp
  extends ListProps,
    FilterPageProps<VoucherReportsFilterKeys, VoucherReportsListFilterOpts>,
    TabPageProps {
  vouchers: VoucherReport_voucherReport_edges_node[];
  onBack: () => void;
  download: () => void;
}

const VoucherListPage: React.FC<VoucherListPageProp> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  vouchers,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();

  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Voucher Report">
          <Button
            color="primary"
            variant="contained"
            disabled={!vouchers}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Voucher"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <VoucherList vouchers={vouchers} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default VoucherListPage;
